import { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion, useScroll } from "framer-motion";
import { ArrowUpRight, Menu, X } from "lucide-react";

const links = [["Our approach", "about"], ["Solutions", "services"], ["Training", "training-delivery"], ["The Srisu difference", "post-training"]];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("");
  const { scrollYProgress } = useScroll();
  const reduced = useReducedMotion();
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    const onResize = () => { if (window.innerWidth >= 1024) setOpen(false); };
    window.addEventListener("keydown", onKey);
    window.addEventListener("resize", onResize);
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) setActive(entry.target.id); });
    }, { rootMargin: "-20% 0px -55% 0px" });
    links.forEach(([, id]) => { const el = document.getElementById(id); if (el) observer.observe(el); });
    return () => { observer.disconnect(); window.removeEventListener("keydown", onKey); window.removeEventListener("resize", onResize); };
  }, []);
  return (
    <header className="site-header" data-testid="site-navbar">
      <nav className="container nav-inner" aria-label="Main navigation">
        <a href="#top" className="brand" data-testid="navbar-logo" aria-label="Srisu Learning Solutions — home" onClick={() => setOpen(false)}>
          <span className="brand-symbol"><img src="/brand/srisu-mark.png" alt="" width="92" height="58" /></span>
          <span className="brand-type">srisu<span>LEARNING SOLUTIONS</span></span>
        </a>
        <div className="desktop-nav">{links.map(([label, id]) => <a key={id} href={`#${id}`} data-testid={`nav-link-${id}`} aria-current={active === id ? "location" : undefined}>{label}</a>)}</div>
        <a href="#enquiry" className="button button-dark nav-cta" data-testid="navbar-cta-button">Let’s talk <ArrowUpRight size={17} /></a>
        <button className="mobile-toggle" data-testid="navbar-mobile-toggle" onClick={() => setOpen(!open)} aria-expanded={open} aria-controls="mobile-navigation" aria-label={open ? "Close navigation" : "Open navigation"}>{open ? <X /> : <Menu />}</button>
      </nav>
      <AnimatePresence>{open && <motion.nav id="mobile-navigation" data-testid="navbar-mobile-menu" className="mobile-nav" aria-label="Mobile navigation" initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: reduced ? 0 : 0.25 }}>
        {links.map(([label, id], i) => <a key={id} href={`#${id}`} data-testid={`mobile-nav-link-${id}`} onClick={() => setOpen(false)}><span>0{i + 1}</span>{label}<ArrowUpRight size={20} /></a>)}
        <a href="#enquiry" data-testid="mobile-nav-cta" onClick={() => setOpen(false)}>Start a conversation <ArrowUpRight size={20} /></a>
      </motion.nav>}</AnimatePresence>
      <motion.div className="reading-progress" style={{ scaleX: scrollYProgress }} aria-hidden="true" />
    </header>
  );
}